export const LIVE_INFO = 'LIVE_INFO';
export const LESSON_INFO = 'LESSON_INFO';
export const REVIEW_INFO = 'REVIEW_INFO';
export const UPDATE_SUBJECTIDS = 'UPDATE_SUBJECTIDS';
export const UPDATE_TEACHER_DISABLED = 'UPDATE_TEACHER_DISABLED';

// 直播场景
export enum LiveLessonType {
  Preparation = 0, // 备课直播
  Other = 1, // 其他直播
}

// 直播类型
export enum LiveType {
  Normal = 0, // 常规直播
  Group = 1, // 分组直播
}


// 课时类型
export enum LessonType {
  None = 0,
  Live = 1, // 直播
  Vod = 2, // 点播
  Material = 3, // 资料
}

 // 直播状态
 export enum LiveState {
  WaitLive = 0, // 等待直播
  OnLive = 1, // 正在直播
  FinishLive = 2, // 结束直播
 }
